import React from 'react'
import Button from './button'



function Footer({ className, children }) {
  return (
    <div className="footer" >
      <div className="line">
        <div className="powered">
          Powered by CoolClimate
        </div>
      </div>
      
    </div>
  )
}

export default Footer